import { empty } from '../helpers';

export class SingleSignOnToken {
  public Token: string = undefined;
  public CustomerKey: string = undefined;
  public Expiration: Date = undefined;

  constructor(source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            case 'Expiration':
              this.Expiration = empty(source.Expiration) ? null : new Date(source.Expiration);
            break;
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }
}
